export const NAVBAR_HEIGHT = 72;
export const NAVBAR_MARGIN = 10;
export const CARD_SPACING = 30;
export const TRIGGER_ANIMATION_SPACING = 30;
export const MIN_SCALE_PERCENT = 0.9;
export const SCALE_FACTOR = 0.02;
